module.exports = __webpack_public_path__ + "img/goods-8.24f1df11.png";